module.exports = __webpack_public_path__ + "img/bg07.2f2504f5.gif";